export default ($wire, $watch) => ({
    customFields: $wire.entangle('customFields').live,
    showSuccessScreen: $wire.entangle('showSuccessScreen').live,
    selectedCampaignIds: $wire.entangle('selectedCampaignIds').live,
    priceOfProperty: $wire.entangle('customFields.price_of_property').live,
    enquirySubmissionInProgress: $wire.entangle('enquirySubmissionInProgress').live,
    enquirySubmittedSuccessfully: $wire.entangle('enquirySubmittedSuccessfully').live,
    init: function () {
        Alpine.effect(() => {
            const selection = Alpine.store('selectedMortgageCampaigns');
            if (typeof selection !== 'undefined') {
                this.setSelectedCampaignIds(selection.values);
            }
        });

        Alpine.store('maxLoanAmount', this.priceOfProperty);

        $watch('priceOfProperty', value => Alpine.store('maxLoanAmount', value));
    },
    setSelectedCampaignIds(ids) {
        this.selectedCampaignIds = ids;
    },
    closeSuccessScreen() {
        this.enquirySubmittedSuccessfully = false;
        this.showSuccessScreen = false;
    },
});
